import { Button } from "@mui/material";
import { useLangContext } from "../../../context/langContext";

const buttonText = {
  fa: "حذف کل",
  en: "remove all",
};

interface IRemoveAllButton {
  removeAllAction: () => void;
}

export default function RemoveAllButton({
  removeAllAction,
}: Readonly<IRemoveAllButton>) {
  const { lang } = useLangContext();

  return (
    <Button
      variant="dangerOutlined"
      sx={{
        paddingY: { xs: "2px", md: "6px" },
        paddingX: { xs: "6px", md: "10px" },
      }}
      onClick={removeAllAction}
    >
      {buttonText[lang]}
    </Button>
  );
}
